// Maps auto-detected feature names from roboflow to our feature IDs
export const AUTO_DETECT_MAPPING = {
  'arch': 'arch',
  'ashlar wall': 'ashlarWall',
  'bevel block': 'bevelBlock',
  'clamps': 'clamps',
  'column': 'column',
  'damage holes': 'damageHoles',
  'hanan pacha': 'hananPacha',
  'hindu temple': 'hinduTemple',
  'lingam': 'lingam',
  'lipped blocks': 'lippedBlocks',
  'niche': 'niche',
  'nubs': 'nubs',
  'pinchmark': 'pinchMark',
  'polygonal wall': 'polygonalWall',
  'pyramid': 'pyramid',
  'sarcophagus': 'sarcophagus',
  'scoop marks': 'scoopMarks',
  'scrape marks': 'scrapeMarks',
  'stairstepmotif': 'stairstepmotif',
  'terraces': 'terraces',
  'vitrification': 'vitrification',
  'wedge holes': 'wedgeHoles'
};

// Validate that all mapped features exist in FEATURE_LABELS
import { FEATURE_LABELS } from './siteFeatures';

const validateMapping = () => {
  const invalidMappings = [];
  for (const [roboflowClass, featureId] of Object.entries(AUTO_DETECT_MAPPING)) {
    if (!FEATURE_LABELS[featureId]) {
      invalidMappings.push([roboflowClass, featureId]);
    }
  }
  
  if (invalidMappings.length > 0) {
    console.error('WARNING: Found invalid feature mappings:', invalidMappings);
  }
};

// Run validation in development
if (import.meta.env.MODE !== 'production') {
  validateMapping();
}
